import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-file-saver-angular',
  template: `
    <p>
      file-saver-angular works!
    </p>
  `,
  styles: [
  ]
})
export class FileSaverAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
